export const isInWix = () => {
  return typeof window !== 'undefined' && window.top !== window.self;
};
